import { User } from '@twilio/conversations';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, HostBinding, Input, OnDestroy } from '@angular/core';

import { SnChatService } from '../../services';

@Component({
  selector: 'sn-user-status',
  templateUrl: './user-status.component.html',
  styleUrls: ['./user-status.component.scss'],
})
export class SnUserStatusComponent implements OnDestroy {
  @Input()
  set sid(value: string) {
    this._chatService
      .getTwilioUser(value)
      .pipe(takeUntil(this._destroy$))
      .subscribe((user: User) => {
        this.user = user;
      });
  }

  @Input() public status: boolean;

  public user: User;

  private readonly _destroy$ = new Subject();

  constructor(private readonly _chatService: SnChatService) {}

  @HostBinding('class.online')
  get online(): boolean {
    return this.status;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
